import React, { useState, useEffect, useRef } from 'react';
import ThirdPartyEmojiPicker from 'emoji-picker-react';
import GiphySearchBox from './GiphySearchBox';
import '../styles/EmojiPicker.css';
//..
function EmojiPicker({ onEmojiSelect, onGifSelect, onClose }) {
  const [activeTab, setActiveTab] = useState('emoji');
  const [searchTerm, setSearchTerm] = useState('');
  const pickerRef = useRef(null);

  const handleEmojiClick = (emojiData) => {
    // emoji-picker-react returns an object {emoji, names, ...}
    onEmojiSelect(emojiData?.emoji || '');
    onClose();
  };

  const handleGifClick = (gifUrl, gifName) => {
    if (onGifSelect) {
      onGifSelect(gifUrl, gifName);
    }
    onClose();
  };

  // Popular GIFs collection
  const popularGifs = [
    { id: 1, url: 'https://media.giphy.com/media/3o7abKhOpu0NwenH3O/giphy.gif', name: 'Happy Dance', category: 'happy' },
    { id: 2, url: 'https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif', name: 'Heart Eyes', category: 'love' },
    { id: 3, url: 'https://media.giphy.com/media/26FLgGTPUDH6UGAbm/giphy.gif', name: 'Thumbs Up', category: 'approval' },
    { id: 4, url: 'https://media.giphy.com/media/3o7abAHdYvZdBNnGZq/giphy.gif', name: 'Clapping', category: 'celebration' },
    { id: 5, url: 'https://media.giphy.com/media/l0MYGb8Q5QVp2x9wQ/giphy.gif', name: 'Dancing', category: 'dance' },
    { id: 7, url: 'https://media.giphy.com/media/26FLdmIp6wJr91JAI/giphy.gif', name: 'Crying', category: 'sad' },
    { id: 8, url: 'https://media.giphy.com/media/l0MYryZTmQgvHI5TG/giphy.gif', name: 'Fire', category: 'awesome' },
    { id: 9, url: 'https://media.giphy.com/media/26FLgGTPUDH6UGAbm/giphy.gif', name: 'OK Hand', category: 'gesture' },
    { id: 12, url: 'https://media.giphy.com/media/26FLdmIp6wJr91JAI/giphy.gif', name: 'Party', category: 'celebration' },
    { id: 13, url: 'https://media.giphy.com/media/3o7abAHdYvZdBNnGZq/giphy.gif', name: 'Peace', category: 'gesture' },
    { id: 14, url: 'https://media.giphy.com/media/l0MYGb8Q5QVp2x9wQ/giphy.gif', name: 'Cool', category: 'awesome' },
    { id: 18, url: 'https://media.giphy.com/media/3o7abAHdYvZdBNnGZq/giphy.gif', name: 'Muscle', category: 'strength' },
    { id: 19, url: 'https://media.giphy.com/media/26FLdmIp6wJr91JAI/giphy.gif', name: 'Confetti', category: 'celebration' },
    { id: 22, url: 'https://media.giphy.com/media/l0MYGb8Q5QVp2x9wQ/giphy.gif', name: 'Perfect', category: 'approval' },
    { id: 23, url: 'https://media.giphy.com/media/3o7absbD7PbTFQa0c8/giphy.gif', name: 'Target', category: 'focus' },
    { id: 24, url: 'https://media.giphy.com/media/26FLgGTPUDH6UGAbm/giphy.gif', name: 'Lightning', category: 'power' },
    { id: 25, url: 'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3a3MxNmJkeGtjNDUwZDVlcnNnNGJ2Zjd6bGRjNzJ0cjdqOHFpNnp6dyZlcD12MV9naWZzX3RyZW5kaW5nJmN0PWc/tsX3YMWYzDPjAARfeg/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 26, url: 'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3aGpsNGJjYmoyaG5sYXI3aGt6dWljNm0wOHB4dm9rMTI3MTB5MmJ0MCZlcD12MV9naWZzX3RyZW5kaW5nJmN0PWc/33zX3zllJBGY8/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 27, url: 'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3a3N6ZHp6Z2N6NjloanJ0YzkzbTgxNWl6MDB5dDQ4a3o2cWY2bmtlZyZlcD12MV9naWZzX3RyZW5kaW5nJmN0PWc/otnqsqqzmsw7K/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 28, url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdjVqdjdybGtxbzA3dXpjN2Fzd3Q1MXlpbXoycDJrYWpoOXE0eGVhMSZlcD12MV9naWZzX3RyZW5kaW5nJmN0PWc/6WFScxN6fi95z3YVQD/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 29, url: 'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3cHJwMXF5dXo2Z2huZDlvbjNrNndwZndqbmw5N2Rrb2RyZHY5ZnQ3bCZlcD12MV9naWZzX3RyZW5kaW5nJmN0PWc/l1KVaj5UcbHwrBMqI/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 30, url: 'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3ZmtpcXFhcjgwdW45N3B0NWpla3FlY3gzb2hsOGs0N3VhZDVsMWRvZyZlcD12MV9naWZzX3RyZW5kaW5nJmN0PWc/OjmrBW4ZQbWjkq6RkC/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 31, url: 'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3cnI2NG9lYTZ1d3NsbG0yY2cxOXFlYjZlbXdxcXl3M3MxZjU3M2podSZlcD12MV9naWZzX3RyZW5kaW5nJmN0PWc/TNSSvY5EPbKp3kPjDc/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 32, url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2doN3Nza3V0NzNobzM0M3BoOGl5ZThxNHExNHdkeWJxdmwwczZubiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/fV8iuSEwLQ6005diSh/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 33, url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExaXZhcTJibmR6a2V2ZndpMWNxNmMxaWRremQxd242dDJtaXR6c3Z3MCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/hxERQNWQudqSF1iDnr/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 34, url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExaDFxYmlnaXF5OHlwcnoyeXg3eGlrYWdrcXNiY3h6a2gzdXY3bXlzMCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3o6ZtgnmZDZeAshxYY/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 35, url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExYjF1eG45cjZpdnZxaTAwa2o3NGY0NGY0dnJoenA3NmI5cXIxeW5wcSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/fWlesbav1qMk8/giphy.gif', name: 'Shocked', category: 'surprise' },
    { id: 36, url: 'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3M2RjbHJlazl6dGlmdTNqMmRjcnVheHVzd3EzbWQwc2l5OHgxeGw5eiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/xT0GqjBCkO9BEiSEOk/giphy.gif', name: 'Shocked', category: 'surprise' },
  ];

  const gifCategories = [
    { id: 'all', name: 'All', icon: '🎭' },
    { id: 'happy', name: 'Happy', icon: '😊' },
    { id: 'love', name: 'Love', icon: '❤️' },
    { id: 'funny', name: 'Funny', icon: '😂' },
    { id: 'awesome', name: 'Awesome', icon: '🔥' },
    { id: 'celebration', name: 'Celebration', icon: '🎉' }
  ];

  const filteredGifs = popularGifs.filter(gif => {
    const matchesSearch = searchTerm === '' || gif.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesSearch;
  });


  // Handle click outside to close picker
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="emoji-picker" ref={pickerRef}>
      {/* Tab Header */}
      <div className="picker-tabs">
        <button 
          className={`tab-btn ${activeTab === 'emoji' ? 'active' : ''}`}
          onClick={() => setActiveTab('emoji')}
        >
          😀 Emojis
        </button>
        <button 
          className={`tab-btn ${activeTab === 'gif' ? 'active' : ''}`}
          onClick={() => setActiveTab('gif')}
        >
          🎬 GIFs
        </button>
        <button 
          className={`tab-btn ${activeTab === 'search' ? 'active' : ''}`}
          onClick={() => setActiveTab('search')}
        >
          🔍 Search
        </button>
      </div>

      {/* Emoji Tab */}
      {activeTab === 'emoji' && (
        <ThirdPartyEmojiPicker
          onEmojiClick={(emojiData) => handleEmojiClick(emojiData)}
          autoFocusSearch={false}
          lazyLoadEmojis
          skinTonesDisabled={false}
          searchDisabled={false}
          previewConfig={{ showPreview: false }}
          height={280}
          width={320}
        />
      )}

      {/* GIF Tab */}
      {activeTab === 'gif' && (
        <div className="gif-picker-content">
          {/* Search Bar */}
          <div className="gif-search">
            <input
              type="text"
              placeholder="Search GIFs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="gif-search-input"
            />
          </div>

          {/* GIF Grid */}
          <div className="gif-grid">
            {filteredGifs.map((gif) => (
              <div
                key={gif.id}
                className="gif-item"
                onClick={() => handleGifClick(gif.url, gif.name)}
              >
                <img
                  src={gif.url}
                  alt={gif.name}
                  className="gif-image"
                  loading="lazy"
                />
                <div className="gif-name">{gif.name}</div>
              </div>
            ))}
          </div>

          {filteredGifs.length === 0 && (
            <div className="no-gifs">
              <p>No GIFs found</p>
            </div>
          )}
        </div>
      )}

      {/* Search Tab */}
      {activeTab === 'search' && (
        <div className="search-tab-content">
          <GiphySearchBox 
            onGifSelect={handleGifClick}
            onClose={onClose}
          />
        </div>
      )}
    </div>
  );
}

export default EmojiPicker;